import { CssBaseline, Grid, withStyles } from '@material-ui/core';
import { AlertDialog, ScrollToTop, Snackbar } from 'components';
import { ConnectedRouter } from 'connected-react-router';
import routes from 'global/routes';
import { createBrowserHistory as createHistory } from 'history';
import IconSvg from 'images/icon.png';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Spin from 'react-reveal/Spin';
import compose from 'recompose/compose';
import translation from 'utils/response';
import Header from './header/Header';
import Nav from './nav/Nav';
import styles from './styles';

const history = createHistory();
const mapStateToProps = ({ app, auth, nav, ...state }) => {
    const { effects } = state.loading;
    const { title } = app;
    const { openLeft: navIsOpen, openRight: rightDrawerIsOpen } = nav;
    const { user, authenticated } = auth;
    return {
        fetching: effects.account.fetch,
        verifying: effects.auth.verify,
        title,
        navIsOpen,
        user,
        authenticated,
        rightDrawerIsOpen,
    };
};

const mapDispatchProps = ({ account, auth, nav }) => ({
    fetchAccount: () => account.fetch(),
    resetAuth: () => auth.resetAuth(),
    refreshToken: () => auth.refreshToken(),
    toggleNav: (payload) => nav.toggleNav(payload),
});

const reduxConnector = connect(mapStateToProps, mapDispatchProps);

class App extends Component {
    state = {};

    static renderVerifying() {
        return (
            <Grid container justify="center" alignItems="center" direction="column" style={{ minHeight: '100vh' }}>
                <Spin forever>
                    <img src={IconSvg} alt="icon-loader" width={80} />
                </Spin>
            </Grid>
        );
    }

    componentDidMount() {
        const { initialize } = this.props;

        initialize({
            languages: [
                { name: 'English', code: 'en' },
            ],
            translation,
            options: { renderToStaticMarkup: false },
        });
    }

    componentDidUpdate(prevProps) {
        const { authenticated, fetchAccount } = this.props;

        if (prevProps.authenticated !== authenticated && authenticated) {
            fetchAccount();
        }
    }

    render() {
        const {
            classes, verifying, fetching, authenticated, title,
        } = this.props;

        return (
            <div>
                <ConnectedRouter history={history}>
                    <ScrollToTop>
                        <CssBaseline />

                        {fetching || verifying ? App.renderVerifying()
                            : (
                                <>
                                    <Helmet defaultTitle="Mapaya">
                                        <title>
                                            {`Mapaya | ${title}`}
                                        </title>
                                    </Helmet>


                                    {authenticated && [
                                        <Header />,
                                        <Nav />,
                                    ]}

                                    <main
                                        className={authenticated ? classes.content : classes.unauthenticatedContent}
                                    >

                                        {authenticated && [
                                            <div className={classes.toolbar} />,
                                        ]}
                                        {routes}

                                    </main>

                                    <AlertDialog />
                                    <Snackbar />
                                </>
                            )}
                    </ScrollToTop>
                </ConnectedRouter>
            </div>
        );
    }
}

export default compose(
    withStyles(styles, { name: 'App' }),
    withLocalize,
    reduxConnector,
)(App);
